import React from 'react'

export const Bell = (color = '#1973B8', width = 14, height = 18) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00065 0.666992C6.31065 0.666992 5.75065 1.22699 5.75065 1.91699V2.49642C3.59497 3.05207 2.00065 5.00433 2.00065 7.33366V12.3337L0.333984 14.0003V14.8337H5.55859C5.41185 15.0869 5.33438 15.3743 5.33398 15.667C5.33398 16.109 5.50958 16.5329 5.82214 16.8455C6.1347 17.1581 6.55862 17.3337 7.00065 17.3337C7.44268 17.3337 7.8666 17.1581 8.17916 16.8455C8.49172 16.5329 8.66732 16.109 8.66732 15.667C8.66642 15.3742 8.58839 15.0867 8.44108 14.8337H13.6673V14.0003L12.0007 12.3337V7.33366C12.0007 5.00433 10.4063 3.05207 8.25065 2.49642V1.91699C8.25065 1.22699 7.69065 0.666992 7.00065 0.666992ZM7.00065 4.00033C8.83898 4.00033 10.334 5.49533 10.334 7.33366V12.3337V13.0238L10.4772 13.167H3.52409L3.66732 13.0238V12.3337V7.33366C3.66732 5.49533 5.16232 4.00033 7.00065 4.00033Z"
        fill={color}
      />
    </svg>
  )
}
